// extracted by mini-css-extract-plugin
module.exports = {"dateHeaderCeil":"DateHeader_dateHeaderCeil__1YzhN","dateHeader":"DateHeader_dateHeader__1cXXr"};